export function formatIntPhoneNumber(phone) {
    if (!phone.startsWith('234')) return phone;
    let number = `0${phone.slice(3)}`;
    return number;
}